import React, { useCallback, useMemo, useRef } from 'react';
import axios, { AxiosInstance } from 'axios';
import NetworkContext, { API_PARDOT, API_UCF } from './network-context';

type apiAddressType = { address: string | undefined };
type apiAddressesType = { [key: string]: apiAddressType };
const apiAddresses: apiAddressesType = {
  [API_UCF]: {
    address: process.env.REACT_APP_API_UCF
  },
  [API_PARDOT]: {
    address: process.env.REACT_APP_API_PARDOT
  }
};

const NetworkProvider: React.FunctionComponent = ({ children }) => {
  const clientsRef = useRef<{ [key: string]: AxiosInstance }>({});

  const createNewClient = useCallback((baseURL) => {
    return axios.create({
      baseURL,
      timeout: 15000,
      headers: {
        'X-Client-Id': `${process.env.REACT_APP_X_CLIENT_ID}`,
        'X-Client-Secret': `${process.env.REACT_APP_X_CLIENT_SECRET}`
      }
    });
  }, []);

  const getClient = useMemo(
    () => (apiType: string): AxiosInstance => {
      // CREATE NEW CLIENT
      if (!clientsRef.current[apiType]) {
        clientsRef.current[apiType] = createNewClient(
          apiAddresses[apiType].address
        );
      }

      return clientsRef.current[apiType];
    },

    [createNewClient]
  );

  return (
    <NetworkContext.Provider
      value={{
        getClient
      }}>
      {children}
    </NetworkContext.Provider>
  );
};

export default NetworkProvider;
